import { Button, Classes, Dialog, FormGroup, } from "@blueprintjs/core";
import { DateInput } from "@blueprintjs/datetime";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as moment from "moment";
import * as React from "react";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { toast } from "react-toastify";
import { getMomentFormatter, toast_error } from "../../utils";
import { formatCnpj } from "../../utils";
import { BootstrapTable, SearchField, TableHeaderColumn, } from "react-bootstrap-table";
import MomentLocaleUtils from "react-day-picker/moment";
import { DateRangePickerSped } from "../utils/DateRangePickerSped";
import { SefaStore } from "../../stores/sefa/SefaStore";
import LoadingModal from "../loading/LoadingModal";

interface Props {
  open: boolean
  onClose: () => void;
}

interface State {
  date3: string;
  date4: string;
  dateRealizar: string;
  dateRealizaDia: any;
  listEmpresas: any[];
}

@observer
export class SolicitacaoSefa extends React.Component<Props, State> {

  obs = observable({
    selectedPeriodSolicitacao: [] as any,
    agora: false as boolean,
    loading: false as boolean,
  })

  constructor(props) {
    super(props);

    this.state = {
      date3: "",
      date4: "",
      dateRealizar: "",
      listEmpresas: [],
      dateRealizaDia: null
    }

  }

  handleDateSolicitacaoChange = (val: any) => {
    var string = val.toString();
    var array = string.split(",");

    this.setState({ date3: moment(array[0]).format("YYYY-MM-DD") });
    this.setState({ date4: moment(array[1]).format("YYYY-MM-DD") });

    this.obs.selectedPeriodSolicitacao = val;
  };

  handleDateRealizarChange = (val: Date) => {
    var string = val.toString();

    var dataAgora = moment().format("YYYY-MM-DD");
    var date1 = moment(string).format("YYYY-MM-DD");

    if (date1 <= dataAgora) {

      toast.warning('Você não pode selecionar uma data inferior ao dia de hoje.', {});
      this.setState({ dateRealizaDia: null, dateRealizar: "" });

      return;

    } else {
      this.setState({ dateRealizaDia: val, dateRealizar: moment(string).format("YYYY-MM-DD") });
    }

  };

  createCustomSearchFieldSol = (props) => {
    return (
      <SearchField
        className="input-filter input-filter-sefa"
        defaultValue={props.defaultSearch}
        placeholder="Filtrar (Razão Social, CNPJ)"
      />
    );
  };

  handleCheckEmpresaChange = async (row, checked) => {

    if (checked) {

      this.setState(state => { state.listEmpresas.push(row.cnpj) });

    } else {

      let index = this.state.listEmpresas.indexOf(row.cnpj);

      this.state.listEmpresas.splice(index, 1);

    }

  };

  handleCheckEmpresas = async (check, row) => {

    if (check) {

      this.setState({ listEmpresas: row?.map(value => value.cnpj) });

    } else {

      this.setState({ listEmpresas: [] });
    }

  };

  handleCloseProgramar = async () => {

    this.props.onClose()

    this.setState({ listEmpresas: [], dateRealizaDia: null, dateRealizar: null });

    this.obs.agora = false

    this.obs.selectedPeriodSolicitacao = []

  };

  isDentroDos5Anos(dataAtualStr: string, dataInicialStr: string): boolean {

    const dataAtual = new Date(dataAtualStr);
    const dataInicial = new Date(dataInicialStr);

    const dataMinima = new Date(dataAtual);

    dataMinima.setFullYear(dataMinima.getFullYear() - 5);

    return dataInicial >= dataMinima && dataInicial <= dataAtual;

  }

  handleProgramarSolicitacoes = async () => {
    const { date3, date4, dateRealizar, listEmpresas } = this.state;
    const { agora } = this.obs;

    const dataFinal = date4;
    const dataRealizar = moment(dateRealizar).format("YYYY-MM-DD");
    const dataAgora = moment().format("YYYY-MM-DD");

    if (listEmpresas.length < 1) {
      toast.warning('Você precisa selecionar as empresas.');
      return;
    }

    if (!date3 || !date4) {
      toast.warning('Você precisa selecionar o período da solicitação.');
      return;
    }

    if ((dataRealizar <= dataFinal) || (agora && dataAgora <= dataFinal)) {
      toast.warning('Você não pode selecionar uma data posterior ao dia da solicitação.');
      return;
    }

    if (!dateRealizar && !agora) {
      toast.warning('Por favor, selecione o campo "Realizar neste momento" ou preencha o campo "Realizar dia" para prosseguir.');
      return;
    }

    if (!this.isDentroDos5Anos(dataAgora, date3)) {
      toast.error("O período informado deve estar dentro dos últimos 5 anos.");
      return;
    }

    try {

      this.props.onClose()

      this.obs.loading = true;

      const payload = {
        data_solicitacao: dateRealizar,
        date1: date3,
        date2: date4,
        list: listEmpresas,
        agora,
        sefa_new: true,
      };

      const resp = await SefaStore.handleProgramar(payload)

      SefaStore.obs.erros_sefa = [];

      if (resp.ok === false) {

        toast.error(resp.msg);

      } else if (resp.length === 0) {

        toast.success('Salvo com sucesso!');

      } else {

        SefaStore.obs.erros_sefa = resp;
        SefaStore.obs.open_erros_sefa = true;
        toast.warning('Solicitação realizada, com ERROS.');

      }

    } catch (ex) {

      toast_error(ex, 'Erro ao programar sua solicitação SEFA, tente novamente mais tarde.');
      this.resetStateAfterFailure();

    } finally {

      this.handleCloseProgramar();

      this.obs.loading = false;

    }

  };

  resetStateAfterFailure = () => {

    this.setState({ listEmpresas: [] });

  };

  render() {

    let dayPickerProps = {
      localeUtils: MomentLocaleUtils,
      locale: "pt-br",
    };

    let empresas = EmpresaStore.sortedEmpresas?.map(emp => {

      return ({
        _id: emp._id,
        razao_social: emp.razao_social,
        cnpj: emp.cnpj,
        cnpj_formated: formatCnpj(emp.cnpj)
      })

    });

    const options_soli = {
      searchField: this.createCustomSearchFieldSol,
    };

    const selectRowProp = {
      mode: "checkbox",
      clickToSelect: true,
      columnWidth: "40px",
      onSelect: this.handleCheckEmpresaChange,
      onSelectAll: this.handleCheckEmpresas,
      selected: this.state.listEmpresas,
    };

    return (
      <>

        <LoadingModal open={this.obs.loading} onClose={() => this.obs.loading = false} title={"Carregando"} />

        <Dialog
          usePortal={true}
          isOpen={this.props.open}
          onClose={() => this.handleCloseProgramar()}
          className="AlertUser modalSefa"
        >
          <h2 className="titleSEFAZ modal-sefa">Programar Solicitação</h2>

          <p style={{ color: "rgba(255, 0, 0, 0.82)" }}>
            <b>Observação:</b> Os arquivos baixados da SEFA permanecem disponíveis no sistema por 90 dias. <br /> Após esse período, será necessário realizar uma nova solicitação para acessá-los.
          </p>

          <FormGroup label="Realizar neste momento:">
            <input
              type="checkbox"
              defaultChecked={this.obs.agora}
              className="chaves"
              onChange={() => {
                this.obs.agora = !this.obs.agora
                this.setState({ dateRealizaDia: null, dateRealizar: "" });
              }}
            />
          </FormGroup>

          {!this.obs.agora &&
            (
              <FormGroup
                label="Realizar dia:"
                className="inputsPeriodoCalculos"
              >
                <DateInput
                  {...getMomentFormatter("DD/MM/YYYY")}
                  locale="pt-br"
                  dayPickerProps={dayPickerProps}
                  placeholder="DD/MM/AAAA"
                  onChange={this.handleDateRealizarChange}
                  value={this.state.dateRealizaDia}
                  canClearSelection
                />
              </FormGroup>
            )}

          <FormGroup
            label="Período de Solicitação:"
            className="inputsPeriodoCalculos"
          >
            <DateRangePickerSped
              onChange={this.handleDateSolicitacaoChange}
              value={this.obs.selectedPeriodSolicitacao}
            />
          </FormGroup>

          <FormGroup
            label="Selecione as Empresas:"
            labelFor="empresas"
          >
            <div className="select-empresa-sefa">
              <BootstrapTable data={empresas} selectRow={selectRowProp} options={options_soli} search>
                <TableHeaderColumn dataField="cnpj" isKey={true} hidden width="0%">#</TableHeaderColumn>
                <TableHeaderColumn dataField="razao_social" width="65%">Razão Social</TableHeaderColumn>
                <TableHeaderColumn dataField="cnpj_formated" width="20%">CNPJ</TableHeaderColumn>
              </BootstrapTable>
            </div>

          </FormGroup>

          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button text="Cancelar" onClick={() => this.handleCloseProgramar()} />
            <Button text="Programar" intent="primary" onClick={() => this.handleProgramarSolicitacoes()} />
          </div>
        </Dialog>

      </>
    );
  }
}

export default SolicitacaoSefa;
